// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__ld7y9","video":"video_video__8kWG_","videobg":"video_videobg__10fDr","videobgWidth":"video_videobgWidth__3ZwEE","videoWrap":"video_videoWrap__3ndvT"};